import * as reducers from './reducers';

export const constants = {
  NAME: 'errors',
};

export default { constants, reducers };
